$(document).ready(function () {
    $('.bf_product_color').click(function (e) {
            e.preventDefault();
            $(this).parents('.bf_product_colors').find('.bf_product_color').removeClass('active');
            $(this).addClass('active');
    });
        
        $('.bf_product_ingredients_heading').click(function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next('.bf_product_ingredients_body').slideToggle();
        });
        $('.bf_loveIt_slider_desktop').owlCarousel({
            nav: false,
            dots: false,
            loop: true,
            responsive: {
                0: {
                    items: 1.3,
                    margin: 14
                },
                768: {
                    items: 1.5,
                    margin: 30,
                },
                992: {
                    items: 2.2,
                    margin: 40,
                }
            }
        })
        $('.bf_loveIt_slider_mobile').owlCarousel({
            nav: false,
            dots: false,
            loop: true,
            responsive: {
                0: {
                    stagePadding: 60,
                    items: 1,
                    margin: 14
                }
            }
        })
        $('.bf_product_testimonial_slider').owlCarousel({
            items: 1,
            margin: 0,
            nav: false,
            dots: true,
        })
       $('.bf_product_hero_img_slider').owlCarousel({
            items: 1,
            margin: 2,
            nav: false,
            dots: true,
        })
        $('.bf_product_details_info_slider').owlCarousel({
            items: 1,
            stagePadding: 70,
            loop: true,
            margin: 15,
            nav: false,
            dots: false,
        })
        $('.bf_product_details_info_slider_main').owlCarousel({
            items: 1.42,
            stagePadding: 0,
            loop: true,
            margin: 15,
            nav: false,
            dots: false,
        });
        let navText = ["<svg focusable='false' width='1.609rem' height='1.325rem ' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg>", "<svg focusable='false' width='1.609rem ' height='1.325rem ' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg>"];
     let previewsSlider = $('.bf_product_preview_slider_main').owlCarousel({
            items: 1,
            loop: false,
            margin: 0,
            navText: navText,
            dots: false,
            responsive: {
                0: {
                    nav: false,
                },
                769: {
                    nav: true,
                }
            }
        });
      $('.bf_product_thumbnail_main').owlCarousel({
            items: 1,
            loop: true,
            margin: 0,
            navText: navText,
            dots: false,
            responsive: {
                0: {
                    nav: false,
                },
                769: {
                    nav: true,
                }
            }
        });

  let mainSlider = $('.bf_product_hero_main_slider').owlCarousel({
            items: 1,
            loop: false,
            dots: false,
            nav: false,
            margin: 3
        })


  $(document).on("change", ".variant-swatch__radio, .bf_product_hero_img_slider .owl-item", function(e){
    let image_url =$(this).attr('data-image');
        $(".bf_product_hero_main_slider .owl-item").each(function(){
        let image_data = $(this).children().find(".bf_product_hero_main_slider_img").attr("data-src");
          if(image_data == image_url){
        $(this).trigger('to.owl.carousel', [$(this).index(), 500]);
        }
        });

  });

  $(document).on("change", ".variant-swatch__radio, .bf_product_preview_slider_main .owl-item", function(e){
        let image_url =$(this).attr('data-image');
    // console.log(image_url, 'img-u');

    $(".bf_product_hero_img_slider .owl-item").each(function(){
        let image_data = $(this).children("#bf_open_carousel").attr("data-src");
              console.log(image_data, 'imgd');
          if(image_data == image_url){
            // console.log("image_data", image_data);
            // console.log("trigger");
        $(this).trigger('to.owl.carousel', [$(this).index(), 500]);
        }
        });
    
              previewsSlider.trigger('to.owl.carousel', [parseInt($(this).text()) - 1, 500]);
 });
// [DEV MN]
  $(document).on("change", ".variant-swatch__radio", function(e){
        let opt_title =$(this).attr('data-opt-title');
        let color = $(this).attr("data-opt-color");
        let image = $(this).attr('data-opt-image');
        let price = $(this).attr('data-price');
        $(".bf_product-option_content-parent").each(function(){
      let title = $(this).attr("data-title");
          if(title == opt_title){
            $(".bf_product-option_content-parent").hide();
            var width = $( window ).width();
            if(width > 768){
           $(this).fadeIn();           
            }else{
            $(this).fadeIn();
            }

          }
        });
    $(".bf_next_crush").css("background", color);
    $('.bf_next_crush img').attr('src', image);
     $(".bf_product_hero_btn .pr_atc-btn").text(price);
    $('.bf_product_hero_text .bf_main_heading.bf_bundle_price.bf_ignore').text(price);
  });

  $(document).ready(function(){
    document.querySelector('[data-title="'+ document.querySelector('.variant-swatch input:checked').value +'"]').style.display = 'block'
  });

       $(document).on("click", ".combo-box__option-item", function(){
       let itm_val = '';
         $(this).each(function(){
         item_val = $(this).val().toLowerCase().trim();           
       });
         $(".variant-swatch__radio:checked").each(function(){
           var itm_opt = $(this).attr("data-opt-title").toLowerCase().trim();
           console.log(itm_opt);
          if(itm_opt == itm_val){
           $(this).trigger("click"); 
            console.log("matched");
          }
         });
         
       console.log(item_val);

     });
  
  $(document).ready(function(){
       let opt_title = $(".variant-swatch input:checked").attr('data-opt-title');
        let color = $(".variant-swatch input:checked").attr("data-opt-color");
    let image = $(".variant-swatch input:checked").attr('data-opt-image');
        $(".bf_swatch-details").each(function(){
      let title = $(this).attr("data-title");
          if(title == opt_title){
            $(".bf_swatch-details").hide();
            $(this).show();
          }
        });
    $(".bf_next_crush").css("background", color);
    $('.bf_next_crush img').attr('src', image)
    
  });
      
        $('.bf_product_navigationBar a').on('click', function (e) {
            e.preventDefault();
            let href = $(this).attr('href');
            $('html, body').animate({
                scrollTop: ($(href).offset().top) - 57
            }, '300');
        });
        $(document).on("click", '.bf_product_previewLink, .bf_product_hero_img_slider .owl-item', function() {
            $('.bf_product_preview_slider').fadeIn();
            $('body').addClass('bf_lock_scroll');
          previewsSlider.trigger('to.owl.carousel', [$(this).index(), 300]);
    });
        $(document).on("click", '.bf_product_previewLink', function() {
        let image_data = $(this).attr("data-image");
              console.log(image_data, 'imgd');
          $(".bf_product_preview_img").each(function(){
            let image_url = $(this).attr("data-img");
            let next_slide = $(this).parent('.owl-item').index();
            if(image_url == image_data){
            console.log("image_url", image_url);
            console.log("trigger-match", next_slide);
        previewsSlider.trigger('to.owl.carousel', [next_slide, 300, true]); ;
        }
        });
        });
          
        $('.bf_product_preview_slider_close_btn').click(function (e) {
            e.preventDefault();
            $('.bf_product_preview_slider').fadeOut();
            $('body').removeClass('bf_lock_scroll');
        });
        $(window).scroll(function () {
            let currentScroll = $(this).scrollTop();
            if (currentScroll > 150) {
                $(".bf_product_navigationBar").addClass("active");
            } else {
                $(".bf_product_navigationBar").removeClass("active");
            }

        });
        $('.bf_product_preview_img').click(function (e) {
            e.preventDefault();
            $(this).toggleClass('zoomed')
        });
    })
